import './inAction.css';

import { useNavigate, useSearchParams } from 'react-router-dom';

import BackgroundImg from '../../../../components/backgroundImg/backgroundImg';
import InActionBackground from '../../../../assets/sectionBackgrounds/inActionBackground/inActionBackground';
import ImageContainer from '../../../../components/imageContainer/imageContainer';
import ToolCards from '../../../../components/toolCards/toolCards';
import SpaceBar from '../../../../components/spacerBars/spaceBar';

export default function InAction({isMobile}){

    const navigate = useNavigate();

    const ExploreButton = () => {
        navigate('/portfolio'); 
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
            });
    };

    return(
        <div className="in-action">
            <BackgroundImg background={<InActionBackground isMobile={isMobile}/>} customClass={'in-action-background-container'}/>
            <div className="in-action-container">
                <div className="in-action-title">
                    <h1>Ready to see expensible in action?</h1>
                    <SpaceBar width={'60%'} color={'var(--background-color)'} />
                </div>
                <div className="in-action-body">
                    <div className="in-action-image">
                        <ImageContainer type={true}/>
                    </div>
                    {isMobile ? 
                    
                    <div className="in-action-cards">
                        <div>
                            <ToolCards 
                            size={true}
                            subTitleTwo="Smarter expense management changes your business"
                            barBool={true}
                            barWidth={'20rem'}
                            bulletPoints={[
                            "Case studies with measurable outcomes and before/after metrics",
                            "Interactive dashboard demo showing tracking, reporting, and forecasting features",
                            "Customer quotes and industry use-cases (freelancers, SMBs, enterprises)",
                            "Technical overview of security, integrations, and deployment options",
                            ]}
                            textContentBottom="Explore our portfolio to learn how Expensable solved real-world budgeting, reporting, and scaling challenges for businesses of all sizes — with screenshots, case summaries, and a live prototype."
                            buttonBool={true}
                            button="Explore!"
                            />
                        </div>
                    </div> 
                    
                    : 
                    
                    <div className="in-action-cards">
                    <div>
                        <ToolCards 
                            size={true}
                            subTitleTwo="Smarter expense management changes your business"
                            barBool={true}
                            barWidth={'20rem'}
                            bulletPoints={[
                            "Case studies with measurable outcomes and before/after metrics",
                            "Interactive dashboard demo showing tracking, reporting, and forecasting features",
                            "Customer quotes and industry use-cases (freelancers, SMBs, enterprises)",
                            "Technical overview of security, integrations, and deployment options",
                            ]}
                            />
                    </div>
                    <div>
                        <ToolCards 
                            subTitle="Explore our portfolio to learn how Expensable solved real-world budgeting, reporting, and scaling challenges for businesses of all sizes — with screenshots, case summaries, and a live prototype."
                            buttonBool={true}
                            button="Explore!"
                            onClick={ExploreButton}
                            />
                    </div>
                    </div> 
                    
                    }
                </div>
            </div>
        </div>
    )
};